import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private loadingSubject = new BehaviorSubject<boolean>(false);
  public loading$ = this.loadingSubject.asObservable();

  private activeLoaders = new Set<string>();

  show(key: string = 'default') {
    this.activeLoaders.add(key);
    this.loadingSubject.next(true);
  }

  hide(key: string = 'default') {
    this.activeLoaders.delete(key);
    if (this.activeLoaders.size === 0) {
      this.loadingSubject.next(false);
    }
  }

  clear() {
    this.activeLoaders.clear();
    this.loadingSubject.next(false);
  }
}
